import styled from 'styled-components';
import media from '../../../styles/theme/breakpoints';

const LoginBoxWrapper = styled.div`
  .MyInfoBox {
    margin-bottom: 11vh;
    display: inline-flex;
  }

  .프로필_이미지 {
    width: 80px;
    height: 80px;
    border-radius: ${({ theme }) => theme.borderRadius.full};
    border: 1px solid ${({ theme }) => theme.colors.neutral[300]};
    box-shadow: ${({ theme }) => theme.elevation.sm};
    cursor: pointer;
  }

  .프로필_이미지_모바일 {
    width: 40px;
    height: 40px;
    border-radius: ${({ theme }) => theme.borderRadius.full};
    border: 1px solid ${({ theme }) => theme.colors.neutral[300]};
    box-shadow: ${({ theme }) => theme.elevation.sm};
    cursor: pointer;
  }

  .사진파일_배경 {
    position: relative;
    display: flex;
    justify-content: center;
    height: 80px;
    overflow: hidden;
    cursor: pointer;
  }

  .사진파일_이미지 {
    padding: 0 0 0 5px;
    font-size: ${({ theme }) => theme.typography.fontSize.base};
    cursor: pointer;
  }

  .사진파일_히든 {
    position: absolute;
    width: 60px;
    height: 60px;
    opacity: 0;
    display: none;
    z-index: 1;
    cursor: pointer;
  }

  .비밀번호찾기,
  .회원가입 {
    &:active, &:link, &:hover, &:visited {
      color: ${({ theme }) => theme.colors.neutral[900]};
    }
  }

  .RadioGroup {
    display: flex;
    justify-content: space-around;
    padding: 0 ${({ theme }) => theme.spacing[5]};
  }

  .LoginTable li {
    list-style-type: none;
    line-height: 40px;
    justify-content: space-around;
  }

  .TabPageBig li {
    list-style-type: none;
  }

  #JoinPopupView {
    display: flex;
    justify-content: center;
    text-align: center;

    input[type=text], input[type=email], input[type=password] {
      width: 100%;
      padding: ${({ theme }) => theme.spacing[3]};
      margin: ${({ theme }) => `${theme.spacing[1]} 0 ${theme.spacing[3]} 0`};
      display: inline-block;
      border: none;
      background: ${({ theme }) => theme.colors.neutral[100]};
      font-size: ${({ theme }) => theme.typography.fontSize.base};
      border-radius: ${({ theme }) => theme.borderRadius.sm};

      &:focus {
        background: ${({ theme }) => theme.colors.neutral[200]};
        outline: none;
      }
    }

    hr {
      border: 1px solid ${({ theme }) => theme.colors.neutral[100]};
      margin-bottom: ${({ theme }) => theme.spacing[4]};
    }

    button {
      background: ${({ theme }) => theme.colors.primary[500]};
      color: ${({ theme }) => theme.colors.neutral[0]};
      padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[5]}`};
      margin: ${({ theme }) => `${theme.spacing[2]} 0`};
      border: none;
      border-radius: ${({ theme }) => theme.borderRadius.base};
      cursor: pointer;
      width: 100%;
      transition: background ${({ theme }) => theme.transition.fast};

      &:hover {
        background: ${({ theme }) => theme.colors.primary[700]};
      }
    }

    .cancelbtn {
      padding: ${({ theme }) => `${theme.spacing[3]} ${theme.spacing[5]}`};
      background: ${({ theme }) => theme.colors.semantic.error};

      &:hover {
        background: #dc2626;
      }
    }

    .cancelbtn, .signupbtn {
      float: left;
      width: 50%;
    }

    .container {
      padding: ${({ theme }) => theme.spacing[4]};
    }

    .clearfix::after {
      content: "";
      clear: both;
      display: table;
    }
  }

  #UserInfoLayout {
    width: 40%;

    b {
      float: left;
      padding-left: ${({ theme }) => theme.spacing[1]};
    }
  }

  @media screen and (max-width: 300px) {
    .cancelbtn, .signupbtn {
      width: 100%;
    }

    #UserInfoLayout {
      width: 90%;
    }
  }

  /* ── 아이디/비밀번호 찾기 ── */
  .find-member-container {
    max-width: 500px;
    margin: 0 auto;
    padding: ${({ theme }) => theme.spacing[5]};
  }

  .SubNavLeft {
    margin-bottom: ${({ theme }) => theme.spacing[4]};

    ul {
      display: flex;
      list-style: none;
      padding: 0;
      margin: 0;
      gap: ${({ theme }) => theme.spacing[2]};
    }

    button {
      background: none;
      border: 1px solid ${({ theme }) => theme.colors.neutral[300]};
      padding: ${({ theme }) => `${theme.spacing[2]} ${theme.spacing[4]}`};
      border-radius: ${({ theme }) => theme.borderRadius.base};
      cursor: pointer;
      font-size: ${({ theme }) => theme.typography.fontSize.base};
      transition: all ${({ theme }) => theme.transition.fast};

      &:hover {
        background: ${({ theme }) => theme.colors.neutral[100]};
      }

      &.TabActive {
        background: ${({ theme }) => theme.colors.primary[500]};
        color: ${({ theme }) => theme.colors.neutral[0]};
        border-color: ${({ theme }) => theme.colors.primary[500]};
      }
    }
  }

  .find-member-layout {
    display: flex;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[5]};

    ${media.tablet} {
      flex-direction: column;
      align-items: center;
    }
  }

  .find-member-logo {
    flex-shrink: 0;

    img {
      width: 80px;
      height: auto;
    }
  }

  .find-member-form {
    flex: 1;
    width: 100%;
  }

  .find-member-field {
    margin-bottom: ${({ theme }) => theme.spacing[3]};

    input {
      width: 100%;
      padding: ${({ theme }) => theme.spacing[3]};
      border: 1px solid ${({ theme }) => theme.colors.neutral[300]};
      border-radius: ${({ theme }) => theme.borderRadius.sm};
      font-size: ${({ theme }) => theme.typography.fontSize.base};
      background: ${({ theme }) => theme.colors.neutral[50]};

      &:focus {
        outline: none;
        border-color: ${({ theme }) => theme.colors.primary[500]};
        background: ${({ theme }) => theme.colors.neutral[0]};
      }
    }

    .LoginButton {
      width: 100%;
      padding: ${({ theme }) => theme.spacing[3]};
      background: ${({ theme }) => theme.colors.primary[500]};
      color: ${({ theme }) => theme.colors.neutral[0]};
      border: none;
      border-radius: ${({ theme }) => theme.borderRadius.base};
      cursor: pointer;
      font-size: ${({ theme }) => theme.typography.fontSize.base};
      transition: background ${({ theme }) => theme.transition.fast};

      &:hover {
        background: ${({ theme }) => theme.colors.primary[700]};
      }
    }
  }

  .find-member-result {
    margin-top: ${({ theme }) => theme.spacing[3]};
    padding: ${({ theme }) => theme.spacing[3]};
    background: ${({ theme }) => theme.colors.neutral[100]};
    border-radius: ${({ theme }) => theme.borderRadius.sm};
    text-align: center;
  }

  .find-member-change-pw {
    margin-top: ${({ theme }) => theme.spacing[4]};
    padding-top: ${({ theme }) => theme.spacing[4]};
    border-top: 1px solid ${({ theme }) => theme.colors.neutral[200]};
  }
`;

export default LoginBoxWrapper;
